import { Button, Flex, Heading, Icon, Spinner, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Layout } from "@lubbezposrednio-frontend/commons";
import { FiCheck, FiX } from "react-icons/fi";
import { confirmGroupSignup } from "@lubbezposrednio-frontend/core";

type State = "loading" | "ok" | "error";

export const GroupSignupConfirmView: React.FC = () => {
  const [params] = useSearchParams();
  const [state, setState] = useState<State>("loading");

  useEffect(() => {
    document.title = "Potwierdzenie zapisu";
    const token = params.get("token");
    if (!token) {
      setState("error");
      return;
    }
    confirmGroupSignup(token)
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <Layout>
      <Flex flex={1} w="100%" align="center" justify="center" px={{ base: "20px", md: "32px" }} py={{ base: "48px", md: "72px" }}>
        <VStack w="100%" maxW="500px" bg="white" borderRadius="24px" boxShadow="0 18px 50px rgba(67,0,152,0.10)" border="1px solid rgba(67,0,152,0.06)" p={{ base: "32px 24px", md: "44px 40px" }} spacing="20px">
          {state === "loading" && <Spinner color="primary" size="lg" thickness="3px" />}

          {state === "ok" && (
            <>
              <Flex w="72px" h="72px" align="center" justify="center" borderRadius="full" bg="rgba(47,206,37,0.14)">
                <Icon as={FiCheck} boxSize="36px" color="#1f9e18" />
              </Flex>
              <Heading fontSize="24px" color="primary" textAlign="center">
                Zapis potwierdzony!
              </Heading>
              <Text color="gray.500" textAlign="center">
                Jesteś już na liście. Otrzymasz zaproszenie, gdy organizator rozpocznie głosowanie.
              </Text>
              <Button as={Link} to="/" bg="primary" color="white" borderRadius="12px" _hover={{ bg: "#36007a" }}>
                Strona główna
              </Button>
            </>
          )}

          {state === "error" && (
            <>
              <Flex w="72px" h="72px" align="center" justify="center" borderRadius="full" bg="rgba(229,31,68,0.12)">
                <Icon as={FiX} boxSize="36px" color="accent" />
              </Flex>
              <Heading fontSize="24px" color="primary" textAlign="center">
                Nie udało się potwierdzić
              </Heading>
              <Text color="gray.500" textAlign="center">
                Link jest nieprawidłowy lub zapis został już potwierdzony.
              </Text>
              <Button as={Link} to="/" variant="ghost" color="primary">
                Strona główna
              </Button>
            </>
          )}
        </VStack>
      </Flex>
    </Layout>
  );
};
